<template>
    <div class="buy-now-new-account-reminder">
        <h3>It's off to the roaster!</h3>
        <img class="sample-bags-img" src="~home/buy-now/pug.png" alt="Sample Bags">
        <h3>Get Coffee on the Reg</h3>

        <div class="account-note">
            <p>1) Add coffees to your brew queue</p>
            <p>2) Choose how often you want deliveries</p>
            <p>3) Rate your coffees as they arrive</p>
        </div>

        <p><strong>Never pay for shipping again!</strong></p>

        <div class="align-center">
            <button class="btn-green-lg create-btn" type="button" @click="navigateToGetStartedPage">Create a free account</button>
        </div>
    </div>
</template>

<script>
    import CommonMixin from "../../../mixins/common-mixin"
    import { validationMixin } from 'vuelidate'
    import { required, minLength, email } from 'vuelidate/lib/validators';
    // Images
    import "home/buy-now/pug.png";

    export default {
        mixins: [
            validationMixin
        ],
        methods: {
            navigateToGetStartedPage() {
                window.location.replace('/coffees/get-started');
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/_variables_home.scss";
    @import "../../../styles/common_home.scss";

    .buy-now-new-account-reminder {
        text-align: center;
        padding: 1.5rem 2rem;
    }
    .sample-bags-img {
        width: 200px;
        height: 100%;
        min-height: 140px;
        margin: 1rem 0;
    }
    .account-note {
        margin: 1.5rem 0;
        p {
            margin: 0.25rem;
        }
    }
    .home-form {
        margin: 0 1rem;
    }
    .create-btn {
        margin-top: 2rem;
    }
</style>
